/**
 * Block component pattern for all blocks
 *
 */
import { Component, Input, Output, EventEmitter, SimpleChanges, OnInit, ViewChild, ElementRef, OnChanges } from '@angular/core';

import { Yii } from "libraries/interfaces/Yii";
import _upperCase from 'lodash-es/upperCase';
import _upperFirst from 'lodash-es/upperFirst';
import { faTimesCircle, faCheckCircle, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export enum Mode {
    inline = "inline",
    detail = "detail",
    head = "head",
    readOnly = "readOnly",
}

export enum Position {
    top = "top",
    bottom = "bottom",
    default = "default",
}

@Component({
    selector: 'ui-click-edit',
    templateUrl: './clickEditModal.component.html',
    styleUrls: ['./clickEditModal.component.scss']
})

export class ClickEditComponent implements OnChanges, OnInit {
    @Input()
    public mode: Mode = Mode.detail;
    public modes: typeof Mode = Mode;
    @Input()
    public icon: string = "";
    @Input()
    public iconDefinition: IconDefinition;
    @Input()
    public unit: string = "";
    @Input()
    public editableValue: string = "";
    @Input()
    public hideEditedField: boolean = false;
    @Input()
    public label: string;
    @Input()
    public pattern: string = ""; // this parameter accept format name and need to be translated in regexp string
    @Input()
    public formLabel: boolean = false;
    @Input()
    public allowValidationOnClickOutside: boolean = true;
    @Input()
    public forceEditablePlaceHolder: boolean = false;
    @Input()
    public charLimit: number;
    @Input()
    public forceFocus: boolean = false;
    @Input()
    public required: boolean = false;
    @Input()
    public buttonPosition: Position = Position.default;
    @Input()
    public permissionPath: string;

    public buttonPositions: typeof Position = Position;

    @Output()
    public readonly returnedValue: EventEmitter<string> = new EventEmitter();

    public focusEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('textInput')
    public textInput: ElementRef;

    // translated strings :

    public t_cancel: string = Yii.t('wui-shared-js', 'Annuler');
    public t_valid: string = Yii.t('wui-shared-js', 'Valider');
    public t_the: string = Yii.t('wui-shared-js', 'le ');
    public t_contain: string = Yii.t('wui-shared-js', ' contient');
    public t_tooMuchChar: string = Yii.t('wui-shared-js', 'caractère en trop, il sera retiré');
    public t_tooMuchChars: string = Yii.t('wui-shared-js', 'caractères en trop, ils seront retirés');

    public editFormIsOpen: boolean = false;
    public formIsActive: boolean = false;
    public tempValue: string | number = "";
    public inputType: string = 'text';

    public inEditionForm: any = {
        'value': ""
    };
    public uiPattern: any = {
        'regexp': '',
        'error': {
            'flag': false,
            'message': ''
        }
    };

    public iconTimesCircle: IconDefinition = faTimesCircle;
    public iconCheckCircle: IconDefinition = faCheckCircle;

    public hasPermission: boolean;

    constructor() {
    }

    public ngOnInit(): void {

        if(this.permissionPath){

        }else {
            this.hasPermission = true;
        }

        this.label = _upperFirst(this.label);
        if (this.editableValue !== "") {
            this.inEditionForm.value = this.editableValue;
            this.tempValue = this.editableValue;
        } else {
            this.inEditionForm.value = "";
            this.tempValue = "";
        }

        if (this.pattern.length > 0) {
            switch (this.pattern) {
                case 'countryCode':
                    this.uiPattern.regexp = /[A-Z]*/g;
                    this.uiPattern.error.message = Yii.t('wui-shared-js', 'Un code pays est attendu ici');
                    this.charLimit = 2;
                    break;
                case 'price':
                    this.uiPattern.regexp = /[1-9]*/g;
                    this.uiPattern.error.message = Yii.t('wui-shared-js', 'Une valeur numérique est attendue ici');
                    this.inputType = 'number';
                    break;
                default:
                    break;
            }
        }
    }

    public ngOnChanges(simpleChanges: SimpleChanges): void {
        if (this.editableValue !== "") {
            this.inEditionForm.value = simpleChanges.editableValue.currentValue;
            this.tempValue = simpleChanges.editableValue.currentValue;
        } else {
            this.inEditionForm.value = "";
            this.tempValue = "";
        }
    }

    public keyAction(event: KeyboardEvent): void {
        if (event.key === 'Tab') {
            this.validate();
        }
        if (event.key === 'Enter') {
            this.validate();
        }
        if (event.key === 'Escape') {
            this.cancel();
        }
    }

    public toggleEditForm(EditFormOpeningState?: boolean): void {
        this.editFormIsOpen = !EditFormOpeningState ? (this.editFormIsOpen) ? this.editFormIsOpen = false : this.editFormIsOpen = true : EditFormOpeningState;
        if (this.editFormIsOpen) {
            this.focusOnTextInput();
        }
    }

    public focusOnTextInput(): void {
        this.forceFocus = true;
        if (this.textInput && this.textInput.nativeElement){
            setTimeout(() => this.textInput.nativeElement.select());
        }
    }

    public checkValidValue(pattern: string): void {
        if (pattern.length > 0) {
            this.uiPattern.error.flag = !this.uiPattern.regexp.test(this.inEditionForm.value);
        }
    }

    public returnForm(): void {
        this.returnedValue.emit(this.inEditionForm.value);
    }

    public validateOnClickOutside(): void {
        if(this.allowValidationOnClickOutside){
            this.validate();
        }
    }
    public validate(): void {
        console.log('validate')
        if (this.pattern === 'countryCode') {
            this.inEditionForm.value = _upperCase(this.inEditionForm.value);
        }
        this.editableValue = this.inEditionForm.value;
        this.returnForm();
        this.toggleEditForm(false);
    }

    public cancel(): void {
        this.inEditionForm.value = this.tempValue;
        this.toggleEditForm(false);
    }

    public openIfNotReadOnlyMode(): void {
        if (!this.isReadOnlyMode()) {
            this.toggleEditForm(false);
        }
    }

    public focusIfNotReadOnlyMode(): void {
        if (!this.isReadOnlyMode()) {
            this.focusOnTextInput();
        }
    }

    public isReadOnlyMode(): boolean {
        return this.isMode(Mode.readOnly);
    }

    public isMode(mode: Mode): boolean {
        return this.mode === mode;
    }
    public isButtonPosition(position: Position): boolean {
        return this.buttonPosition === position;
    }

    public canShowFormLabel(): boolean {
        return (this.editableValue === '' && !this.editFormIsOpen) || this.formLabel;
    }

    public hasEditableValueAndFormLabel(): boolean {
        return this.editableValue !== '' && this.formLabel;
    }

    public hasVisibleEditableValue(): boolean {
        return this.editableValue !== '' && !this.hideEditedField;
    }

    public hasHiddenEditableValue(): boolean {
        return this.editableValue !== '' && this.formLabel;
    }

    public hasIcon(): boolean {
        return this.icon !== '';
    }
}
